import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { toggleSide } from 'src/store/ducks/general/actions'

import { WrapIcon } from './styles'

function HamburgerMenu() {
  const dispatch = useDispatch()

  const {
    general: { collapsedSide }
  } = useSelector((state: ApplicationState) => ({
    general: state.general
  }))
  return (
    <WrapIcon
      onClick={() => dispatch(toggleSide())}
      type={collapsedSide ? 'menu-unfold' : 'menu-fold'}
    />
  )
}

export default HamburgerMenu
